import { render, staticRenderFns } from "./OfferItemCategory.vue?vue&type=template&id=1daf3368"
import script from "./OfferItemCategory.vue?vue&type=script&lang=js"
export * from "./OfferItemCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1daf3368')) {
      api.createRecord('1daf3368', component.options)
    } else {
      api.reload('1daf3368', component.options)
    }
    module.hot.accept("./OfferItemCategory.vue?vue&type=template&id=1daf3368", function () {
      api.rerender('1daf3368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OfferItemCategory.vue"
export default component.exports